/** Campos enviados em PATCH /nsmps/{id}/digitacao */
const DIGITACAO_FIELDS = [
  'tipoServico',
  'motivo',
  'numLinhasPlanilha',
  'quantidadePostes',
  'nsmpProgramada',
  'nsmp',
  'latitude',
  'longitude',
  'coordenada',
  'observacaoDigitador',
];

export const pickDigitacaoPayload = (values) => {
  const payload = { id: values.id };
  DIGITACAO_FIELDS.forEach((field) => {
    if (values[field] !== undefined) {
      payload[field] = values[field];
    }
  });
  return payload;
};

export default pickDigitacaoPayload;
